import { DateTime } from 'luxon';
import { TimesheetLabel } from '../../../timesheet-labels/labelSchema';
import { NoteFormData } from '../noteSchema';
import { mapFormFieldsToTimesheetLabels } from './note-utils';

export const isNoteNonEmpty = (value: NoteFormData): boolean => {
  return (
    !!value.note ||
    !!value.duration ||
    !!value.startTime ||
    !!value.endTime ||
    atLeastOneValueInTimesheetLabels(
      mapFormFieldsToTimesheetLabels(value.timesheetLabels)
    )
  );
};

export const roundedDuration = (duration: number): number => {
  const d = Math.floor(duration / 60);
  return d;
};

export const validateDuration = (
  startDate: DateTime,
  endDate: DateTime,
  duration: number
): boolean => {
  const startEndDuration = endDate.diff(startDate, ['seconds']).seconds;
  return roundedDuration(duration) > roundedDuration(startEndDuration);
};

export const atLeastOneValueInTimesheetLabels = (
  timesheetLabels: TimesheetLabel[] = []
): boolean => {
  return timesheetLabels.some((label: TimesheetLabel) => {
    return doesTimesheetLabelHaveValue(label);
  });
};

export const doesTimesheetLabelHaveValue = (label: TimesheetLabel): boolean => {
  return !!label?.value?.stringValue || !!label?.value?.numericValue;
};
